/**
 * Display-only mapping for Salesforce stage picklist values.
 * Do not use for API payloads or filter values — those must keep the exact picklist strings.
 */
export const STAGE_DISPLAY_LABELS = {
  '00 - Entrata': 'Entrata',
  '01 - Tenant Evaluation': 'Resident Evaluation',
  '02 - Document Verification and Onboarding': 'Document Verification',
  '02A - Final Review': 'Final Review',
  '04 - Agreement Signed': 'Payment',
  '05 - Policy Issued': 'Policy Issued',
  '06 - Policy Declined': 'Policy Declined',
  'Cancelled Application': 'Cancelled Application',
  'Duplicate Application': 'Duplicate Application',
  'Policy Fully Refunded': 'Policy Fully Refunded',
};

/** Aggregated dashboard chart buckets (display only; drill-down keys stay on picklist values). */
export const ALL_APPLICATIONS_CHART_LABELS = {
  potentialApps: 'Potential Apps',
  pendingApps: 'Pending Apps',
  pendingPayment: 'Pending Payment',
  policyIssued: STAGE_DISPLAY_LABELS['05 - Policy Issued'],
  declinedApplication: 'Declined Application',
  cancelledApplication: STAGE_DISPLAY_LABELS['Cancelled Application'],
};

export const PERFORMANCE_REVIEW_CHART_LABELS = {
  pendingApplications: 'Pending Applications',
  approved: 'Approved',
  declined: 'Declined',
  cancelled: 'Cancelled',
};

const LEADING_STAGE_CODE = /^(?:\d{2}A?|\d)\s*-\s*/;

export function stageLabelForDisplay(value) {
  if (value == null || value === '') return value;
  const key = String(value);
  if (STAGE_DISPLAY_LABELS[key]) return STAGE_DISPLAY_LABELS[key];
  return key.replace(LEADING_STAGE_CODE, '').replace(/^Tenant Evaluation$/, 'Resident Evaluation');
}
